import React, { useState } from "react";
import {
  menuUrl,
  tableTitle,
  keyColumn,
  tableColumn,
  breadCrumbs,
  filters as rawFilters,
} from "@screens/user-administration/users/users-list/model/users-list.constants";
import { getFilterData } from "@utils/common";
import {
  constructFilterDataAndGetQueryString,
  getFilterQueryString,
} from "@utils/filters.util";
import { APP, PRIMARY_KEY } from "@constants/app.constants";
import { useHistory } from "react-router-dom";
import { checkMenuAccess } from "@utils/menu-auth";
import {
  deleteUsersDataApi,
  getUsersDataApi,
} from "./users-list.component.service";
import MESSAGES from "@constants/messages.constants";
import { useDispatch, useSelector } from "react-redux";
import { setAlertMessage } from "@reducers/alert.reducer";
import UsersListTemplateComponent from "./users-list-template.component";
import PermissionDeniedComponent from "@screens/permission-denied/permission-denied.component";
import { getAllRoles } from "../users-create/users-create.component.service";
import { useEffect } from "react";

const {
  ALERT_TYPES: { SUCCESS, ERROR },
  USER_ALERTS: { DELETE_ALERT },
} = MESSAGES;
const { ROWS_PER_PAGE } = APP;

const UsersListComponent = () => {
  const { filterList } = useSelector((state) => state.filter);
  const [tableData, setTableData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const history = useHistory();
  const dispatch = useDispatch();
  const filters = getFilterData(filterList, menuUrl, "filter");
  const menuAccess = checkMenuAccess(menuUrl, "read");
  const [roles, setRoles] = useState([]);

  const getUsersData = async (params = null) => {
    // console.log({ params });
    const queryStr = getFilterQueryString(menuUrl, params);
    const usersData = await getUsersDataApi({
      ...params,
      filters: queryStr,
    });
    if (usersData.status) {
      // console.log(usersData);
      setTableData(usersData.data);
      setTotalCount(usersData.totalCount);
    }
  };

  const handleCreateClick = () => {
    history.push(`/${menuUrl}/create`);
  };

  const deleteRecords = async (selected) => {
    const deleteAccess = checkMenuAccess(menuUrl, "delete");
    if (deleteAccess) {
      const response = await deleteUsersDataApi(selected);
      if (response.status) {
        dispatch(
          setAlertMessage({ type: SUCCESS, message: DELETE_ALERT, viewed: 0 })
        );
        getUsersData({
          orderBy: "created_at",
          sortBy: "desc",
          skip: 0,
          limit: ROWS_PER_PAGE,
        });
      } else {
        dispatch(
          setAlertMessage({ type: ERROR, message: response.message, viewed: 0 })
        );
      }
    } else
      dispatch(
        setAlertMessage({
          type: ERROR,
          message: "Permission denied to delete",
          viewed: 0,
        })
      );
  };

  const handleDownload = async (filters = null) => {
    const queryStr = getFilterQueryString(menuUrl, filters);
    // console.log("download triggered", filters, queryStr);
    // // console.log({
    //   url: `${SETTING_EXPORT}?token=${token}${queryStr}`,
    // });
  };

  const submitFilter = (filters) => {
    // console.log({ filtersFromList: filters });
    const queryStr = constructFilterDataAndGetQueryString(filters, menuUrl);
    // console.log({ queryStr });
    getUsersData({
      orderBy: "created_at",
      sortBy: "desc",
      skip: 0,
      limit: ROWS_PER_PAGE,
      filters: queryStr,
    });
  };

  const onLoad = async () => {
    const rolesListResponse = await getAllRoles();
    if (rolesListResponse.status) {
      const formatedRoleList = rolesListResponse.data.map((data) => {
        return {
          name: data.role_name,
          value: data[PRIMARY_KEY],
        };
      });
      setRoles(formatedRoleList);
    }
  };

  useEffect(() => {
    onLoad();
  }, []);

  return menuAccess ? (
    <UsersListTemplateComponent
      templateModal={{
        tableTitle,
        keyColumn,
        breadCrumbs,
        tableColumn,
        tableData,
        totalCount,
        filters: filters ? filters : rawFilters({ roles }),
      }}
      templateEvents={{
        getUsersData,
        handleCreateClick,
        deleteRecords,
        handleDownload,
        submitFilter,
      }}
    />
  ) : (
    <PermissionDeniedComponent />
  );
};

export default UsersListComponent;
